import React from 'react';
import { PRICING_FEATURE_ROWS } from '../../constants/pricingFeatures';

/**
 * @param {{ variant: 'landing' | 'modal', className?: string }} props
 */
const PricingFeaturesComparison = ({ variant = 'modal', className = '' }) => {
  const p = variant === 'landing' ? 'pricing' : 'premium';
  const isLanding = variant === 'landing';

  return (
    <div className={`${p}-features-comparison ${className}`.trim()}>
      <div className={`${p}-features-header`}>
        <span className={`${p}-features-header-label`}>
          {isLanding ? 'Funktion' : ''}
        </span>
        {isLanding && <span className={`${p}-features-header-guest`}>Gæst</span>}
        <span className={`${p}-features-header-free`}>Basis</span>
        <span className={`${p}-features-header-premium`}>Premium</span>
      </div>

      {PRICING_FEATURE_ROWS.map((row) => (
        <div key={row.id} className={`${p}-feature-row`}>
          <span className={`${p}-feature-label`}>{row.label}</span>
          {isLanding && (
            <span className={`${p}-feature-guest`}>{row.guest}</span>
          )}
          <span className={`${p}-feature-free`}>{row.basis}</span>
          <span className={`${p}-feature-premium`}>{row.premium}</span>
        </div>
      ))}
    </div>
  );
};

export default PricingFeaturesComparison;
